import { createTheme } from '@mui/material/styles';

export default createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1280,
      xl: 1536,
    },
  },
  typography: {
    h6: {
      fontSize: 12,
    },
    // h4: {
    //   fontSize: 18,
    // },
    fontFamily: 'JohnsonText, sans-serif', // replace with JnJ font
  },
  palette: {
    primary: {
      main: '#312C2A',
    },
    secondary: {
      main: '#E8E6E3',
      dark: '#C1BBB3',
    },
    text: {
      primary: '#312C3A',
    },
    background: {
      default: '#f7f7f7',
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variant: 'body2',
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          zIndex: 1310,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 36,
          textTransform: 'none'
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          borderRadius: 36,
          textTransform: 'none'
        },
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none'
        },
      }
    },
    MuiDataGrid: {
      defaultProps: {
        density: 'comfortable',
        pagination: true,
        pageSize: 10,
      },
      styleOverrides: {
        root: {
          padding: 0,
          backgroundColor: 'white',
          '& .MuiButton': {
            color: '#564C47'
          }
        },
        // The code below results in a console error and seems to be redundant. Leaving it here in case there's problems elsewhere in the application
        // fix for 'no results/no rows' overlay that doesn't render correctly when data grid has horizontal scrolling
        // main: {
        //   '> div:first-child:not([class])': {
        //     width: '100% !important',
        //     // 72px is the height of the header. Change this when the header height changes
        //     height: 'calc(100% - 72px) !important',
        //     top: 'unset !important',
        //     bottom: 0,
        //   },
        // },
      },
    },
  },
});
